<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">
            <div class="form-col">
                <control type="hidden" v-model="family.id" :hasError="!!errors.id" id="id"/>
            </div>
            <div class="form-col">
                <field :label="$t('class.name')" class="w-full md:w-1/2 px-2 " :hasError="errors.name">
                    <control type="text" v-model="family.name"/>
                </field>
                <field :label="$t('family.relation')" class="w-full md:w-1/2 px-2" :hasError="errors.relation">
                    <select class="input-form-select focus:ring focus:outline-none ring-red-600 ring-offset-2 dark:placeholder-gray-400" v-model="family.relation">
                        <option value="" disabled selected>Select</option>
                        <option value="Spouse">Spouse</option>
                        <option value="Parents">Parents</option>
                        <option value="Children">Children</option>
                        <option value="Siblings">Siblings</option>
                        <option value="Others">Others</option>
                    </select>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('employee.dateOfBirth')" class="w-full md:w-2/2 px-2 " :hasError="errors.date_of_birth">
                    <datepicker v-model="family.date_of_birth" :enableTimePicker="false" name="date_of_birth" :auto-apply="true"></datepicker>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('family.isEmployee')" class="w-full md:w-1/2 px-2 " :hasError="errors.is_employee">
                    <control :options="boolean" v-model="family.is_employee"/>
                </field>
                <field :label="$t('family.isStudent')" class="w-full md:w-1/2 px-2" :hasError="errors.is_student">
                    <control :options="boolean" v-model="family.is_student"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('employee.mobileNum')" class="w-full md:w-1/2 px-2 " :hasError="errors.mobile_no">
                    <control type="text" v-model="family.mobile_no"/>
                </field>
                <field :label="$t('employee.email')" class="w-full md:w-1/2 px-2" :hasError="errors.email">
                    <control type="text" v-model="family.email"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-2">
                    <control type="text" v-model="family.remarks"/>
                </field>
            </div>
            <!-- <div class="form-col">
                <field :label="$t('lessonplan.file')" class="w-full md:w-2/2 px-2">
                    <input type="file" accept="image/*, .pdf, .doc, .docx" v-on:change="onFileChange" class="form-control-file" id="idcardFile">
                </field>
            </div> -->
            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const boolean = [{id: true, name:'Yes'}, {id: false, name:'No'}]
        const preview = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const family = reactive({
            id: '',
            name: '',
            relation: '',
            date_of_birth: '',
            is_employee: '',
            is_student: '',
            mobile_no: '',
            email: '',
            remarks: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                }
                reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
            }
        }

        const resetForm = () => {
            family.id = ''
            family.name = ''
            family.relation = ''
            family.date_of_birth = ''
            family.is_employee = ''
            family.is_student = ''
            family.mobile_no = ''
            family.email = ''
            family.remarks = ''
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'family/' + family.id : 'family'
            const method = props.showEdit ? 'PUT' : 'POST'

            family.created_by = userlogin
            family.file = preview.value

            const jsonData = JSON.stringify(family)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };
            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if (response.data.success) {
                        emit('close-modal')
                        emit('refresh-list')
                        resetForm()
                        toast.success(response.data.message)
                    } else {
                        errors.value = response.data.messages
                        toast.error(response.data.messages)
                    }
                    // console.log(errors.value)
                    isLoading.value = false
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error)
                        toast.error(error.response.data.message)
                        console.log(JSON.stringify(error.request))
                    } else if (error.message) {
                        console.log(error.message)
                        toast.error(error.message)
                        console.log(JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // family.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            family.file = ''
            family.description = ''
        })

        watchEffect(() => {
            const newobject = props.propObject
            Object.assign(family, newobject)

            if (!props.showEdit) {
                family.id = null
                family.name = null
                family.relation = null
                family.date_of_birth = null
                family.is_employee = null
                family.is_student = null
                family.mobile_no = null
                family.email = null
                family.remarks = null
            }

            const newfamily = props.propClass
            family.submenu = newfamily.submenu
            family.ein = newfamily.ein
            family.employee_id = newfamily.employee_id
            family.nickname = newfamily.nickname
        })

        return {
            titleStack,
            onFileChange,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            boolean,
            router,
            family,
            store,
            toast,
            userlogin,
            errors,
            isLoading,
            resetForm
        }
    },
    methods: {

        clearForm () {
            this.family = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
